import ptBrLocale from "date-fns/locale/pt-BR";
import enLocale from "date-fns/locale/en-US";
import esLocale from "date-fns/locale/es";

import { TLanguages } from "@languages/languageData";
import useTranslation from "@languages/useTranslation";

export const getDateLocale = () => {
  const { i18n } = useTranslation();

  switch (i18n.language as TLanguages) {
    case "pt-BR":
      return ptBrLocale;
    case "en-US":
      return enLocale;
    case "es":
      return esLocale;
    default:
      return enLocale;
  }
};
